import React from "react";
import InventoryPage from "./InventoryPage";
import InventorySubTablePage from "./InventorySubTablePage";

// checks the URL and what pathname is present
// if the pathname is /inventory_items, it will render InventorySubTablePage
// if not, it will render InventoryPage
const InventoryRouter: React.FC = () => {
	const isPathnameInventoryItems =
		window.location.pathname === "/inventory_items";

	return isPathnameInventoryItems ? (
		<InventorySubTablePage />
	) : (
		<InventoryPage />
	);
};

export default InventoryRouter;
